import type { CoursesAdminEventFeedQueryDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type { AdminGetEventFeedInput, AdminGetEventFeedOutput } from '../../types/event-feed.types';

const TAG = 'courses:event-feed' as const;

export const eventFeedEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		adminGetEventFeed: builder.query<AdminGetEventFeedOutput, AdminGetEventFeedInput>({
			query: (params) => ({
				url: 'courses/admin/platform/event-feed',
				params: params satisfies Wire<CoursesAdminEventFeedQueryDto>,
			}),
			providesTags: [TAG],
		}),
		/**
		 * Cursor-paged variant of `adminGetEventFeed` for the admin event viewer ("Load more"):
		 * the filters are the query arg and `cursor` is the page param, so a refetch (polling,
		 * realtime, tag invalidation) re-fetches every loaded page in order.
		 */
		adminGetEventFeedPages: builder.infiniteQuery<
			AdminGetEventFeedOutput,
			Omit<AdminGetEventFeedInput, 'cursor'>,
			string | undefined
		>({
			infiniteQueryOptions: {
				initialPageParam: undefined,
				getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
			},
			query: ({ queryArg, pageParam }) => ({
				url: 'courses/admin/platform/event-feed',
				params: { ...queryArg, cursor: pageParam },
			}),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useAdminGetEventFeedQuery,
	useLazyAdminGetEventFeedQuery,
	useAdminGetEventFeedPagesInfiniteQuery,
} = eventFeedEndpoints;
